/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type ContactCodeType = typeof ContactCodeType[keyof typeof ContactCodeType];


export const ContactCodeType = {
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  TEXT: 'TEXT',
} as const;
